module.exports = __webpack_public_path__ + "img/symbol-apple-w.58bcd4e8.svg";